export default __webpack_public_path__ + "static/media/theme_scifi.f741438f.jpg";